import { styled, useTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import '../../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import Icon from '../../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../../Icon/icons.js';
import '../../Icon/helper.js';
import 'react-spring/renderprops.cjs';
import Badge from '../../Badge/Badge.js';
import '../../ClickOutside/ClickOutside.js';
import Tooltip from '../../Tooltip/Tooltip.js';

const BadgeWrapper = styled(Div)`
  display: flex;
  padding: ${({
  theme
}) => theme.spacing.xs}px;
  align-items: center;
`;

const GroupTitleWrapper = styled(Div)`
  display: flex;
  justify-content: space-between;
`;

const NameWrapper = styled(Div)`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled(Div)`
  display: flex;
  align-items: center;
  padding: ${({
  theme
}) => theme.spacing.sm}px;
  color: ${({
  isOpen,
  theme
}) => isOpen ? theme.palette.text.primary : theme.palette.text.secondary};
`;

const Name = styled(Div).attrs(({
  theme,
  isOpen
}) => ({
  fontSize: theme.typography.fontSizeLarge,
  fontWeight: theme.typography.fontWeightRegular,
  color: isOpen ? theme.palette.text.primary : theme.palette.text.secondary
}))``;

const GroupTitle = ({
  isOpen,
  title,
  numberOfAppliedFilters,
  infoTooltip
}) => {
  const theme = useTheme();
  const isTooltipVisible = infoTooltip && infoTooltip.length > 0;
  return /*#__PURE__*/createElement(GroupTitleWrapper, null, /*#__PURE__*/createElement(NameWrapper, null, /*#__PURE__*/createElement(IconWrapper, {
    isOpen: isOpen
  }, /*#__PURE__*/createElement(Icon, {
    glyph: icons.CHEVRON_DOWN,
    rotate: isOpen ? 0 : -90,
    size: 24
  })), /*#__PURE__*/createElement(Div, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/createElement(Name, {
    isOpen: isOpen
  }, title), isTooltipVisible && /*#__PURE__*/createElement(Tooltip, {
    message: infoTooltip,
    styles: {
      root: {
        ml: `${theme.spacing.xs}px`
      },
      bubble: {
        width: '210px'
      }
    }
  }, /*#__PURE__*/createElement(Icon, {
    glyph: icons.INFO_CIRCLE,
    size: 24,
    styles: {
      root: {
        mr: `${theme.spacing.xxs}px`
      }
    }
  })))), /*#__PURE__*/createElement(BadgeWrapper, null, /*#__PURE__*/createElement(Badge, {
    text: numberOfAppliedFilters,
    styles: {
      root: {
        bg: theme.palette.black['20'],
        color: theme.palette.text.primary,
        fontSize: theme.typography.fontSizeLarge,
        minWidth: '25px'
      }
    }
  })));
};

export default GroupTitle;
